import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { whatsappNumbersQuery } from "../../lib/whatsapp/whatsappNumbersQuery"

export function useUpdateWhatsappNumberCompanyMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ id, companyId }: { id: string; companyId: string }) => {
      await axios.patch(`/integrations/whatsapp/numbers/${id}/company`, { companyId })
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: whatsappNumbersQuery().queryKey })
    },
  })
}
